import { styled } from '@mui/material';
import { Form } from 'formik';

export const StyledGoalsCreateStep3Form = styled(Form)({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	justifyContent: 'center',
});

export const StyledGoalsCreateStep3FormItems = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',

	'& ul': {
		paddingInline: '32px',
	},

	gap: '8px',
	minWidth: '0px',
}));
